<template>
    <div>
        <v-tabs>
            <v-tab>Bookmarks</v-tab>
            <v-tab>RSS</v-tab>
        </v-tabs>
    </div>
</template>

<script>
    import { Component, Vue } from 'vue-property-decorator';

    @Component({})
    export default class CommonHeader extends Vue {
    }
</script>

<style scoped>

</style>